package com.essntl.features.contact.ui.contactdetails

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.address.ui.AddressEvent
import com.essntl.features.address.ui.AddressState
import com.essntl.features.address.ui.AddressValidation
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.contact.ui.ContactScreen
import com.essntl.features.contact.ui.ContactState
import com.essntl.features.contact.ui.ContactValidation
import com.essntl.features.customfields.ui.CustomFieldsEvent
import com.essntl.features.customfields.ui.CustomFieldsScreen
import com.essntl.features.customfields.ui.CustomFieldsState
import com.essntl.toastmanager.ToastManager
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import org.koin.compose.koinInject
import addedittravelagent.AddEditTravelAgentState
import addedittravelagent.ProposalsAndItinerariesSection
import com.essntl.features.contact.ui.ContactNavigation

@Composable
fun ContactDetailsScreen(
    state: ContactState,
    onNavigation: (ContactNavigation) -> Unit,
    onEvent: (ContactEvent) -> Unit,
    validation: ContactValidation,
    addressState: AddressState,
    onAddressEvent: (AddressEvent) -> Unit,
    addressValidation: AddressValidation,
    customFieldsState: CustomFieldsState,
    travelAgentState: AddEditTravelAgentState? = null,
    onCustomFieldsEvent: (CustomFieldsEvent) -> Unit,
    isSaveEnabled: Boolean,
) {
    val toastManager = koinInject<ToastManager>()

    LaunchedEffect(addressState.getAddress.data) {
        addressValidation.addressForm.reset()
        addressValidation.addressForm.line1.value = addressState.getAddress.data?.line1.orEmpty()
        addressValidation.addressForm.city.value = addressState.getAddress.data?.city.orEmpty()
        addressValidation.addressForm.country.value = addressState.getAddress.data?.country.orEmpty()
    }

    LaunchedEffect(addressState.addEditAddress.isSuccess) {
        if (addressState.addEditAddress.isSuccess) {

            onEvent(
                ContactEvent.UpdateContactFields(
                    state.contact.value.copy(
                        address = addressState.addEditAddress.data,
                    ),
                ),
            )

            onEvent(ContactEvent.EditContact)

            onAddressEvent(AddressEvent.ClearSuccessState)
        }
    }

    LaunchedEffect(state.editContact.isSuccess) {
        if (state.editContact.isSuccess) {
            onCustomFieldsEvent(
                CustomFieldsEvent.AddEditCustomFields(
                    state.contact.value.id,
                ),
            )

            onEvent(ContactEvent.ClearSuccessState)
        }
    }

    LaunchedEffect(
        customFieldsState.addEditTravelAgent.isSuccess,
        customFieldsState.addEditSupplier.isSuccess,
    ) {
        if (customFieldsState.addEditTravelAgent.isSuccess ||
            customFieldsState.addEditSupplier.isSuccess
        ) {
            toastManager.success(
                description = "Contact Updated Successfully",
            )

            onCustomFieldsEvent(CustomFieldsEvent.ClearSuccessState)
        }
    }


    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier.fillMaxSize(),
    ) {
        Box(
            modifier =
                Modifier
                    .weight(1f),
        ) {
            Column(
                verticalArrangement = Arrangement.spacedBy(1.spacing),
                modifier =
                    Modifier
                        .fillMaxHeight()
                        .padding(end = 1.5f.spacing)
                        .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
                        .verticalScroll(rememberScrollState()),
            ) {
                ContactScreen(
                    state = state,
                    onEvent = onEvent,
                    validation = validation,
                    addressState = addressState,
                    onAddressEvent = onAddressEvent,
                    addressValidation = addressValidation,
                )

                CustomFieldsScreen(
                    state = customFieldsState,
                    onEvent = onCustomFieldsEvent,
                )

                travelAgentState?.let { taState ->
                    ProposalsAndItinerariesSection(
                        proposals = taState.getProposals.data.orEmpty(),
                        itineraries = taState.getItineraries.data.orEmpty(),
                        onEditProposalClicked = { onNavigation(ContactNavigation.EditProposal(it)) },
                        onEditItineraryClicked = { onNavigation(ContactNavigation.EditItinerary(it)) },
                    )
                }
            }
        }

        Spacer(modifier = Modifier.height(1.dp))

        Box(
            modifier = Modifier
                .background(MaterialTheme.esColorScheme.bgSecondary)
                .padding(2.5.spacing),
        ) {
            EsLargePrimaryButton(
                onClick = {
                    val validateContact = validation.contactForm.validate()

                    val validateContactAddress =
                        (if (state.addAddress) addressValidation.addressForm.validate() else true)

                    if (validateContact &&
                        validateContactAddress
                    ) {
                        if (state.addAddress)
                            if (addressState.address.value.id.isEmpty())
                                onAddressEvent(AddressEvent.AddAddress) else
                                onAddressEvent(AddressEvent.EditAddress)
                        else
                            onEvent(ContactEvent.EditContact)
                    }
                },
                loading = state.editContact.isLoading ||
                    addressState.addEditAddress.isLoading ||
                    customFieldsState.addEditSupplier.isLoading ||
                    customFieldsState.addEditTravelAgent.isLoading,
                text = "Save",
                enabled = isSaveEnabled,
                modifier = Modifier.fillMaxWidth(),
            )
        }
    }
}